import { PersonalDataUserFormType } from 'entities/users/types';
import { UserProfileType } from 'entities/user/model/types';

export const useUpdatePersonalDataDefaultValues = (user: UserProfileType): PersonalDataUserFormType => ({
  first_name: user?.first_name ?? '',
  last_name: user?.last_name ?? '',
  middle_name: user?.middle_name ?? '',
  iin: user?.iin ?? '',
  document_number: user?.document?.document_number ?? '',
  issued_at: user?.document?.issued_at ?? null,
  expiration_at: user?.document?.expiration_at ?? null,
  personal_number: user?.document?.personal_number ?? null,
  city_id: user?.city_id ?? null,
  country_id: user?.city?.country_id,
});
